import { Pie, PieChart, Legend, Cell, Sector } from 'recharts';
import { useState } from 'react';
import './FacetFieldPiecharts.scss';
import { tokens } from '@fluentui/react-components';

const FacetFieldPiecharts = ({ selectedFilterData, facetSelection, onChangeFacetPie, fieldName, name, pieDataArr }: any) => {
    const [activeIndex, setActiveIndex] = useState(-1);
    const [showTooltip, setTooltipFlag] = useState(false);

    if (!facetSelection) {
        return null;
    }

    let piechartName = name;

    if (piechartName.indexOf('/') > 0) {
        piechartName = piechartName.split('/')[0];
    }
    
    const legendMouseEnter = (index: any) => {
        setActiveIndex(index);
        let elementDiv = document.getElementById('legend-' + fieldName + '-' + index);

        let scrollWidth = elementDiv?.scrollWidth;
        let offsetWidth = elementDiv?.offsetWidth;
        if (scrollWidth !== undefined && offsetWidth !== undefined && scrollWidth > offsetWidth) {
            setTooltipFlag(true);
        } else {
            setTooltipFlag(false);
        }
    };

    const legendMouseLeave = () => {
        setActiveIndex(-1);
    };

    // Implementing custom legend content
    const CustomLegend = (props: { payload: any }) => {
        const { payload } = props;
        const fieldNameResult = selectedFilterData.find((f: { name: any }) => f.name === fieldName);
        return (
            <div className="custom-legend">
                {payload.map((entry: any, index: number) => (
                    <div key={`legend-${index}`} style={{ color: entry.color }}>
                        <div style={{ display: 'inline-block', overflow: 'hidden' }}>
                            <span
                                className={`legend-icon ${
                                    fieldNameResult !== undefined && fieldNameResult.values.indexOf(entry.value) !== -1 && 'legend-icon-big'
                                }`}
                            >
                                ●
                            </span>
                        </div>
                        <div id={`legend-${fieldName}-${index}`} className="legend-div" title={showTooltip ? entry.value : undefined}>
                            <span
                                className={`legend-text ${activeIndex === index && 'legend-text-bold'}`}
                                onMouseEnter={() => legendMouseEnter(index)}
                                onMouseLeave={() => legendMouseLeave()}
                                onClick={(e) => onChangeFacetPie({ name: entry.value }, fieldName)}
                            >
                                {entry.value}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const renderActiveShape = (props: any) => {
        const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, value } = props;
        return (
            <g>
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius + 10}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                />
                <text x={cx} y={cy} textAnchor="middle" fill={tokens.colorNeutralForeground1}>
                    {value}
                </text>
            </g>
        );
    };

    const getColor = (index: number, colorCount: number): string => {
        if (colorCount < 13) colorCount = 13;

        const stepSize = 360 / colorCount;
        const offset = 240;
        const hslValue = (offset + stepSize * index) % 360;

        return 'hsl(' + hslValue + ', 60%, 60%)';
    };

    return (
        <div className="piechart-div">
            <h3 className="piechart-header">{piechartName}</h3>
            {pieDataArr.length === 0 && (
                <PieChart width={300} height={180}>
                    <Legend
                        iconType="circle"
                        iconSize={8}
                        layout="vertical"
                        verticalAlign="middle"
                        align="right"
                        wrapperStyle={{
                            padding: '0 0rem',
                            height: '50%',
                            width: '45%',
                            overflow: 'auto',
                            right: '-10px',
                        }}
                    />
                    <Pie
                        dataKey="value"
                        data={[{ name: 'No data available', value: 1, fill: '#eeee' }]}
                        blendStroke
                        className="focus:outline-none"
                        cx="50%"
                        cy="50%"
                        innerRadius="45%"
                        outerRadius="95%"
                    ></Pie>
                </PieChart>
            )}
            {pieDataArr.length > 0 && (
                    <PieChart width={300} height={180}>
                        <Legend
                            iconType="circle"
                            iconSize={8}
                            layout="vertical"
                            verticalAlign="middle"
                            align="right"
                            wrapperStyle={{
                                padding: '0 0rem',
                                height: '95%',
                                width: '40%',
                                overflowX: 'hidden',
                                right: '-10px',
                                whiteSpace: 'nowrap',
                                top: '5px',
                            }}
                            content={<CustomLegend payload={undefined} />}
                        />
                        <Pie
                            activeShape={renderActiveShape}
                            activeIndex={activeIndex}
                            startAngle={90}
                            animationDuration={550}
                            animationEasing="ease-in-out"
                            endAngle={-270}
                            dataKey="value"
                            data={pieDataArr}
                            blendStroke
                            className="focus:outline-none"
                            labelLine={false}
                            cx="50%"
                            cy="50%"
                            innerRadius="45%"
                            outerRadius="95%"
                            isAnimationActive={true}
                            minAngle={12}
                            onClick={(e) => onChangeFacetPie(e, fieldName)}
                            onMouseEnter={(_, index) => setActiveIndex(index)}
                            onMouseLeave={() => setActiveIndex(-1)}
                        >
                            {pieDataArr.map((entry: any, index: number) => (
                                <Cell key={`cell-${index}`} fill={getColor(index, pieDataArr.length)} />
                            ))}
                        </Pie>
                    </PieChart>
            )}
        </div>
    );
};

export default FacetFieldPiecharts;
